
import React, {useEffect, useState} from 'react';
import {
  Box,
  Button, Card, CardContent,
  CircularProgress,
  FormControl, GlobalStyles,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  Menu,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent, ToggleButton, ToggleButtonGroup,
  Typography, useTheme
} from '@mui/material';
import './MatchStattingPage.css';
import {
  acePoint, attackInNetPoint,
  attackKillPoint,
  attackOutPoint,
  blockCoveredTransitionPoint,
  blockKillPoint,
  faultPoint, serveInNetPoint,
  serveOutPoint,
  dugTransitionPoint, freeBallTransitionPoint, serveFaultPoint, toolKillPoint
} from "../../services/statting.service";
import {deletePoint, getPoints, savePoint} from "../../services/point.service";
import {createEmptyPlayerStats, PlayerWithSideInfo} from "sandy-shared/dist/types/player-info.type";
import {StattedPoint} from "sandy-shared/dist/types/statted-point.type";
import {
  isErrorServe,
  ServeInPlayLocation,
  serveInPlayLocationMatches,
  ServeOutLocation,
  ServePlayerRelativeLocation,
  ServiceOutcome
} from "sandy-shared/dist/types/servce-info.type";
import {
  AttackDestinationLocation,
  AttackOriginLocation,
  AttackOriginLocationVertical,
  AttackOutcome,
  AttackOutLocation,
  AttackType, destinationLocationMatches, isAttackWithDestinationLocation, isAttackWithoutAttackType, isAttackWithoutAttackTypeOrOriginLocation, isAttackWithoutDestinationLocation, isAttackWithOutLocation,
  originLocationMatches,
  PassType,

} from "sandy-shared/dist/types/attack-info.type";
import {CourtSide} from "sandy-shared/dist/types/court-info.type";
import { PlayerStatsDto } from 'sandy-shared/dist/dtos/player.dto';
import {useParams} from "react-router-dom";
import {completeSet, getMatch, startNewSet, updateMatch} from "../../services/match.service";
import {enqueueSnackbar} from "notistack";
import {StattedPointDto} from "sandy-shared/dist/dtos/statted-point.dto";
import {CompleteSetDto} from "sandy-shared/dist/dtos/match-actions.dto";
import {calculatePlayersStatsFromPoints} from "sandy-shared/dist/analysis/analysis-helpers";
import {getServeInPlayLocation, getAttackDestinationLocation, getAttackOriginLocationHorizontal} from "../../shared/utility/shared-court-actions";
import {CurrentPointState, EphemeralPointState, PartnershipWithState, PlayerStatsWithId} from "./MatchStattingPage-types";
import {assertAllDefined} from "sandy-shared/dist/utils/misc-utils";
import Court, {CourtProps} from "../../components/Court";
import {StattedPointWithUiInfo, addUiInfoToPoints} from "../../shared/utility/statted-point-helpers";
import {MatchStattingLeftSidebar, MatchStattingLeftSidebarProps} from "./components/MatchStattingLeftSidebar";
import MatchStattingSettingsModal, {MatchStattingSettings} from "./components/MatchStattingSettingsModal";
import MatchPartnershipContainer, {MatchPartnershipContainerProps} from "./components/MatchPartnershipContainer";
import { MatchInfoDto } from 'sandy-shared/dist/dtos/match-info.dto';

const sandActiveColor = '#c2b280';
const SECTION_SELECTED_COLOR = '#1565c0';
const defaultSwitchTotal = 7;

// Button colors for point outcomes
const SERVING_TEAM_POINT_COLOR = '#d32f2f'; // Red
const RECEIVING_TEAM_POINT_COLOR = '#388e3c'; // Green

const defaultSettings: MatchStattingSettings = { autoSetServer: true, autoSwapSides: true, keepScore: true };
const practiceSetting: MatchStattingSettings = { autoSetServer: false, autoSwapSides: false, keepScore: false };

const MatchStattingPage = () => {
  const theme = useTheme();

  const routeParams = useParams<Record<string, string>>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSavingPoint, setIsSavingPoint] = useState<boolean>(false);
  const [isCompletingSet, setIsCompletingSet] = useState<boolean>(false);
  const matchId = parseInt(routeParams["matchId"]!);
  const [match, setMatch] = useState<MatchInfoDto>();
  const [selectedSetId, setSelectedSetId] = useState<number>();

  const [currentPointState, setCurrentPointState] = useState<CurrentPointState>(CurrentPointState.PendingServe);
  const [homePartnership, setHomePartnership] = useState<PartnershipWithState>();
  const [awayPartnership, setAwayPartnership] = useState<PartnershipWithState>();
  const [initialTopPartnershipId, setInitialTopPartnershipId] = useState<number>();

  const [servingPlayerId, setServingPlayerId] = useState<number>();
  const [topPartnershipId, setTopPartnershipId] = useState<number>();
  const [allPlayerStats, setAllPlayerStats] = useState<PlayerStatsWithId[]>([]);
  const [fullPointHistory, setFullPointHistory] = useState<StattedPointWithUiInfo[]>([]);
  const [pointHistory, setPointHistory] = useState<StattedPointWithUiInfo[]>([]);
  const [selectedPointId, setSelectedPointId] = useState<number | null>(null);

  const [selectedServeInPlayLocation, setSelectedServeInPlayLocation] = useState<ServeInPlayLocation | undefined>(undefined);
  const [selectedPassType, setSelectedPassType] = useState<PassType | undefined>(undefined);
  const [selectedAttackOriginLocation, setSelectedAttackOriginLocation] = useState<AttackOriginLocation | undefined>(undefined);
  const [selectedAttackDestinationLocation, setSelectedAttackDestinationLocation] = useState<AttackDestinationLocation | undefined>(undefined);
  const [selectedAttackType, setSelectedAttackType] = useState<AttackType | undefined>(undefined);
  const [selectedAttackOutLocation, setSelectedAttackOutLocation] = useState<AttackOutLocation | undefined>(undefined);
  const [selectedServeOutLocation, setSelectedServeOutLocation] = useState<ServeOutLocation | undefined>(undefined);
  const [undoActionStack, setUndoActionStack] = React.useState<(() => void)[]>([])
  const [showServeReceiveLocationsOverride, setShowServeReceiveLocationsOverride] = useState<boolean | undefined>(undefined);
  const [showAttackLocationsOverride, setShowAttackLocationsOverride] = useState<boolean | undefined>(undefined);

  const [matchStattingSettings, setMatchStattingSettings] = useState<MatchStattingSettings>(defaultSettings);
  const [matchStattingSettingsModalOpen, setMatchStattingSettingsModalOpen] = useState<boolean>(false);

  const servingPartnership = [homePartnership?.playerOne?.id, homePartnership?.playerTwo?.id].includes(servingPlayerId) ? homePartnership : awayPartnership;
  const receivingPartnership = servingPartnership?.id === homePartnership?.id ? awayPartnership : homePartnership;
  const topPartnership = homePartnership?.id === topPartnershipId ? homePartnership : awayPartnership;
  const bottomPartnership = homePartnership?.id === topPartnershipId ? awayPartnership : homePartnership;
  const courtIsRotated = servingPartnership?.id === bottomPartnership?.id;
  const selectedSet = match?.sets?.find(s => s.id === selectedSetId);

  const mostRecentPartnershipServer = (partnershipId: number, points: StattedPoint[]) => {
    const reversedPoints = [...points].reverse();
    const lastServicePoint = reversedPoints.find(p => p.servingPartnershipId === partnershipId);
    return lastServicePoint?.serverPlayerId;
  }

  const nextServerId = (partnership: PartnershipWithState, points: StattedPoint[]) => {
    const lastServer = mostRecentPartnershipServer(partnership.id, points);
    return lastServer === partnership.playerOne.id ? partnership.playerTwo.id : partnership.playerOne.id;
  }

  const fetchAndUpdateSetPointHistory = (season: string, setId: number) => {
    getPoints(season, setId)
      .then(points => {
        setFullPointHistory(addUiInfoToPoints(points, homePartnership!.id));
      })
      .catch(e => {
        console.error('Failed to get points:', e);
        enqueueSnackbar('Failed to get points', {variant: 'error', autoHideDuration: 5000});
      })
  }

  //region State update wrappers
  const updateServingPartnershipState = (state: PartnershipWithState | undefined) => {
    if(servingPartnership?.id === homePartnership?.id) {
      setHomePartnership(state);
    } else {
      setAwayPartnership(state);
    }
  }

  const updateReceivingPartnershipState = (state: PartnershipWithState | undefined) => {
    if(receivingPartnership?.id === homePartnership?.id) {
      setHomePartnership(state);
    } else {
      setAwayPartnership(state);
    }
  }

  const updateTopOrBottomPartnershipState = async (isTop: boolean, state: PartnershipWithState | undefined) => {
    const targetPartnership = isTop ? topPartnership : bottomPartnership;
    const targetPartnershipIsHome = targetPartnership?.id === homePartnership?.id;
    const isNewPartnership = state && state?.id !== targetPartnership?.id; // This happens when a player is swapped mid-match (usually in practice mode)
    if(isNewPartnership) {
      await updateMatch(matchId, targetPartnershipIsHome ? {homePartnershipId: state.id} : {awayPartnershipId: state.id});
      if(initialTopPartnershipId === targetPartnership?.id) {
        setInitialTopPartnershipId(state.id);
      }
      if(topPartnershipId === targetPartnership?.id) {
        setTopPartnershipId(state.id);
      }
    }
    if(targetPartnershipIsHome) {
      setHomePartnership(state);
    } else {
      setAwayPartnership(state);
    }
  }
  //endregion

  //region UseEffect hooks
  useEffect(() => {
    setIsLoading(true);
    getMatch(matchId).then(match => {
      console.log('Got Match:', match);
      setMatch(match);
      setSelectedSetId(match.sets[0].id);
      const homePartnership =  {
        ...match.homePartnership,
        playerOne: {...match.homePartnership.playerOne, side: CourtSide.Left},
        playerTwo: {...match.homePartnership.playerTwo, side: CourtSide.Right},
        score: 0
      }
      const awayPartnership =  {
        ...match.awayPartnership,
        playerOne: {...match.awayPartnership.playerOne, side: CourtSide.Left},
        playerTwo: {...match.awayPartnership.playerTwo, side: CourtSide.Right},
        score: 0
      }
      setHomePartnership(homePartnership);
      setAwayPartnership(awayPartnership);
      setTopPartnershipId(homePartnership.id);
      setInitialTopPartnershipId(homePartnership.id);
      setAllPlayerStats([
        {playerId: homePartnership.playerOne.id, ...createEmptyPlayerStats()},
        {playerId: homePartnership.playerTwo.id, ...createEmptyPlayerStats()},
        {playerId: awayPartnership.playerOne.id, ...createEmptyPlayerStats()},
        {playerId: awayPartnership.playerTwo.id, ...createEmptyPlayerStats()}
      ]);
      setServingPlayerId(homePartnership.playerOne.id);
      setMatchStattingSettings(match.type === 'Practice' ? practiceSetting : defaultSettings);
    })
    .catch(e => {
      console.error('Failed to get match:', e);
      enqueueSnackbar('Failed to get match', {variant: 'error', autoHideDuration: 5000});
    })
    .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    console.log(`Home partnership: ${homePartnership?.id}: ${homePartnership?.score}`);
    console.log(`Away partnership: ${awayPartnership?.id}: ${awayPartnership?.score}`);
  }, [homePartnership, awayPartnership]);

  useEffect(() => {
    if(!selectedSetId || !match?.season) return;
    fetchAndUpdateSetPointHistory(match.season, selectedSetId);
  }, [selectedSetId, match]);

  useEffect(() => {
    const lastPoint = pointHistory.length > 0 ? pointHistory[pointHistory.length - 1] : null;

    const servingPartnershipScore = matchStattingSettings.keepScore
      ? pointHistory.filter(p => p.winningPartnershipId === servingPartnership!.id).length
      : 0;
    const receivingPartnershipScore = matchStattingSettings.keepScore
      ? pointHistory.filter(p => p.winningPartnershipId === receivingPartnership!.id).length
      : 0;
    console.log('Last Point:', JSON.stringify(lastPoint));

    updateServingPartnershipState({...servingPartnership!, score: servingPartnershipScore});
    updateReceivingPartnershipState({...receivingPartnership!, score: receivingPartnershipScore});

    if(!lastPoint) return;

    // If we have a selected point, we want to see who was serving for that point, in normal operation we want to see who is serving for the _next_ point
    if(selectedPointId !== null) {
      setServingPlayerId(lastPoint.serverPlayerId);
    } else {
      if(lastPoint.winningPartnershipId !== servingPartnership!.id && matchStattingSettings.autoSetServer) {
        const newServerId = nextServerId(receivingPartnership!, pointHistory);
        setServingPlayerId(newServerId);
      }
    }
    const playerAndPartnershipIds = [
      {playerId: homePartnership!.playerOne.id, partnershipId: homePartnership!.id},
      {playerId: homePartnership!.playerTwo.id, partnershipId: homePartnership!.id},
      {playerId: awayPartnership!.playerOne.id, partnershipId: awayPartnership!.id},
      {playerId: awayPartnership!.playerTwo.id, partnershipId: awayPartnership!.id}
    ];
    const allPlayerStats = playerAndPartnershipIds.map(pap => ({playerId: pap.playerId, ...calculatePlayersStatsFromPoints(pointHistory, [pap.playerId], pap.partnershipId)}));
    setAllPlayerStats(allPlayerStats);
  }, [pointHistory, matchStattingSettings]);

  // We do this outside of the main point history update to make sure that all the state is updated before we check for a switch
  useEffect(() => {
    const switchTotal = matchStattingSettings.autoSwapSides ? defaultSwitchTotal : 9999999;
    const scoreTotal = (topPartnership?.score ?? 0) + (bottomPartnership?.score ?? 0);
    const moddedPoints = scoreTotal % (switchTotal * 2);
    if(scoreTotal === 0 && topPartnership?.id !== initialTopPartnershipId) { // This happens when initialTopPartnershipId is changed by a manual court side swap
      setTopPartnershipId(initialTopPartnershipId)
    } else if(scoreTotal > 0 && moddedPoints >= switchTotal && topPartnership?.id === initialTopPartnershipId) {
      setTopPartnershipId(bottomPartnership?.id);
    } else if (scoreTotal > 0 && moddedPoints < switchTotal && topPartnership?.id !== initialTopPartnershipId) {
      setTopPartnershipId(bottomPartnership?.id);
    }
  }, [homePartnership, awayPartnership, initialTopPartnershipId]);

  useEffect(() => {
    if(selectedPointId === null) {
      setPointHistory(fullPointHistory)
      return;
    }
    const points = []
    for (const point of fullPointHistory) {
      points.push(point)
      if(point.id === selectedPointId) {
        break;
      }
    }

    setPointHistory(points);
    displayPointOnCourt(points[points.length - 1]);
  }, [selectedPointId]);

  // This prevents any desync if a point is added while we're viewing history (which shouldn't happen, but just in case)
  useEffect(() => {
    setPointHistory(fullPointHistory)
  }, [fullPointHistory]);
  //endregion

  const displayPointOnCourt = (point: StattedPointDto)=> {
    setCurrentPointState(CurrentPointState.Fault); // This disables all court buttons
    setShowAttackLocationsOverride(false);
    setShowServeReceiveLocationsOverride(true);

    if(isErrorServe(point.serveInfo)) {
      const result = {summary: 'Missed Serve', detail: `Missed Serve: ${point.serveInfo.outLocation}`};
      setSelectedServeOutLocation(point.serveInfo.outLocation);
      return result;
    }
    setSelectedServeInPlayLocation(point.serveInfo.inPlayLocation);

    if(point.serveInfo.outcome === ServiceOutcome.Ace) {
      const result = {summary: 'Ace', detail: `Ace: ${point.serveInfo.inPlayLocation.side}, ${point.serveInfo.inPlayLocation.playerRelativeLocation}`};
      return result;
    }

    if(!point.attackInfo) {
      console.error('Point has serve in place but no attack info:', point);
      return;
    }
    setShowAttackLocationsOverride(true);
    setShowServeReceiveLocationsOverride(false);

    if(isAttackWithoutAttackTypeOrOriginLocation(point.attackInfo)) {
      const result = {summary: 'Transition', detail: 'Free Ball'};
      setCurrentPointState(CurrentPointState.FreeBallTransition); // This is how the highlighting is done for free balls, since it isn't an attack location
      return result;
    }

    setSelectedAttackOriginLocation(point.attackInfo.originLocation);

    if(isAttackWithoutDestinationLocation(point.attackInfo)) {
      const result = {summary: point.attackInfo.outcome, detail: point.attackInfo.outcome};
      return result;
    }

    if(isAttackWithDestinationLocation(point.attackInfo)) {
      const result = {summary: `${point.attackInfo.outcome} (${point.attackInfo.attackType})`, detail: `${point.attackInfo.outcome} (${point.attackInfo.attackType}): ${point.attackInfo.destinationLocation}`};
      setSelectedAttackDestinationLocation(point.attackInfo.destinationLocation);
      return result;
    }

    if(isAttackWithOutLocation(point.attackInfo)) {
      const result = {summary: `${point.attackInfo.outcome} (${point.attackInfo.attackType})`, detail: `${point.attackInfo.outcome} (${point.attackInfo.attackType}): ${point.attackInfo.outLocation}`};
      setSelectedAttackOutLocation(point.attackInfo.outLocation);
      return result;
    }

    if(isAttackWithoutAttackType(point.attackInfo)) {
      const result = {summary: point.attackInfo.outcome, detail: point.attackInfo.outcome};
      return result;
    }
  }

  //region Styling
  const attackDestinationSectionStyle = (rowIndex: number, colIndex: number) => {
    const attackDestinationLocation = getAttackDestinationLocation(rowIndex, colIndex);
    return {backgroundColor: destinationLocationMatches(selectedAttackDestinationLocation, attackDestinationLocation) ? SECTION_SELECTED_COLOR : undefined}
  }

  const attackOriginSectionStyle = (attackLocationIndex: number) => {
    const attackLocation = {horizontal: getAttackOriginLocationHorizontal(attackLocationIndex), vertical: AttackOriginLocationVertical.On};;
    return {backgroundColor: originLocationMatches(selectedAttackOriginLocation, attackLocation) ? SECTION_SELECTED_COLOR : undefined}
  };


  const freeBallLocationSectionStyle = () => {
    return {backgroundColor: currentPointState === CurrentPointState.FreeBallTransition ? SECTION_SELECTED_COLOR : undefined}
  };

  const serveReceiveSectionStyle = (locationIndex: number) => {
    const serveReceiveLocation = getServeInPlayLocation(locationIndex);
    return {backgroundColor: serveInPlayLocationMatches(selectedServeInPlayLocation, serveReceiveLocation) ? SECTION_SELECTED_COLOR : undefined}
  }

  const attackOutOfBoundsLocationStyle = (location: AttackOutLocation) => ({
    backgroundColor: location === selectedAttackOutLocation ? SECTION_SELECTED_COLOR : undefined
  });

  const serveOutOfBoundsLocationStyle = (location: ServeOutLocation) => ({
    backgroundColor: location === selectedServeOutLocation ? SECTION_SELECTED_COLOR : undefined
  });

  const receivingOutOfBoundsAdditionalClasses = () => currentPointState === CurrentPointState.PendingServe ? 'clickable-court-section' : undefined
  const receivingInBoundsAdditionalClasses = () => currentPointState === CurrentPointState.PendingServe ? 'clickable-court-section' : undefined
  const attackLocationOrFreeAdditionalClasses = () => currentPointState === CurrentPointState.PassGraded ? 'clickable-court-section' : undefined
  const shotLocationAdditionalClasses = () => currentPointState === CurrentPointState.AttackTypeSelected ? 'clickable-court-section' : undefined
  const attackingOutOfBoundsAdditionalClasses = () => currentPointState === CurrentPointState.AttackTypeSelected ? 'clickable-court-section' : undefined
  const showAttackLocations = () => currentPointState !== CurrentPointState.PendingServe
  const showServeReceiveLocation = () => currentPointState === CurrentPointState.PendingServe
  //endregion

  //region Undo
  const resetEphemeralPointState = () => {
    const previousEphemeralPointState: EphemeralPointState = {
      serveInPlayLocation: selectedServeInPlayLocation,
      passType: selectedPassType,
      attackDestinationLocation: selectedAttackDestinationLocation,
      attackOriginLocation: selectedAttackOriginLocation,
      attackOutLocation: selectedAttackOutLocation,
      attackType: selectedAttackType,
      currentPointState: currentPointState
    };

    setSelectedServeInPlayLocation(undefined);
    setSelectedPassType(undefined);
    setSelectedAttackDestinationLocation(undefined);
    setSelectedAttackOriginLocation(undefined);
    setSelectedAttackOutLocation(undefined);
    setSelectedAttackType(undefined);
    setSelectedServeOutLocation(undefined);
    setShowAttackLocationsOverride(undefined);
    setShowServeReceiveLocationsOverride(undefined);
    setCurrentPointState(CurrentPointState.PendingServe);
    return previousEphemeralPointState;
  }

  const setEphemeralPointState = (state: EphemeralPointState) => {
    setSelectedServeInPlayLocation(state.serveInPlayLocation);
    setSelectedAttackDestinationLocation(state.attackDestinationLocation);
    setSelectedAttackOriginLocation(state.attackOriginLocation);
    setSelectedAttackOutLocation(state.attackOutLocation);
    setSelectedAttackType(state.attackType);
    setCurrentPointState(state.currentPointState);
  }

  const pushUndoAction = (action: () => void) => {
    setUndoActionStack(stack => [...stack, action]);
  }

  const popUndoAction = () => {
    const undoAction = undoActionStack[undoActionStack.length - 1];
    setUndoActionStack(stack => stack.slice(0, stack.length - 1));
    return undoAction;
  }

  const handleUndoClick = () => {
    if(undoActionStack.length === 0) {
      return
    }
    const undoAction = popUndoAction();
    undoAction();
  }

  const canUndo = () => undoActionStack.length > 0;
  //endregion

  //region Intermediate statting state handlers
  const assertPointState = (forState: string, expectedState: CurrentPointState) => {
    if(currentPointState !== expectedState) {
      console.log(`Invalid state for ${forState}, expected ${expectedState}, but was ${currentPointState}`);
      return false;
    }
    return true;
  }

  const handleServeReceiveSectionClick = (locationIndex: number) => {
    if(!assertPointState('handleServeReceiveSectionClick', CurrentPointState.PendingServe)) return;

    setCurrentPointState(CurrentPointState.ServeInPlay);
    const location = getServeInPlayLocation(locationIndex);
    setSelectedServeInPlayLocation(location);

    pushUndoAction(() => {
      setSelectedServeInPlayLocation(undefined)
      setCurrentPointState(CurrentPointState.PendingServe);
    })
  };

  const handlePassGradeClick = (passType: PassType) => {
    if(!assertPointState('handlePassGradeClick', CurrentPointState.ServeInPlay)) return;

    setCurrentPointState(CurrentPointState.PassGraded);
    setSelectedPassType(passType);

    pushUndoAction(() => {
      setSelectedPassType(undefined);
      setCurrentPointState(CurrentPointState.ServeInPlay);
    })
  }

  const handleAttackTypeClick = (attackType: AttackType) => {
    if(!assertPointState('handleAttackTypeClick', CurrentPointState.AttackOriginSelected)) return;

    setCurrentPointState(CurrentPointState.AttackTypeSelected);
    setSelectedAttackType(attackType);

    pushUndoAction(() => {
      setSelectedAttackType(undefined);
      setCurrentPointState(CurrentPointState.AttackOriginSelected);
    })
  }

  const handleAttackOriginClick = (locationIndex: number) => {
    if(!assertPointState('handleAttackOriginClick', CurrentPointState.PassGraded)) return;

    const attackLocation = {horizontal: getAttackOriginLocationHorizontal(locationIndex), vertical: AttackOriginLocationVertical.On};;
    setSelectedAttackOriginLocation(attackLocation);
    setCurrentPointState(CurrentPointState.AttackOriginSelected);

    pushUndoAction(() => {
      setSelectedAttackOriginLocation(undefined);
      setCurrentPointState(CurrentPointState.PassGraded);
    })
  }

  const handleAttackDestinationSectionClick = (rowIndex: number, colIndex: number) => {
    if(!assertPointState('handleAttackDestinationSectionClick', CurrentPointState.AttackTypeSelected)) return;

    const attackDestinationLocation = getAttackDestinationLocation(rowIndex, colIndex);
    setSelectedAttackDestinationLocation(attackDestinationLocation);
    setCurrentPointState(CurrentPointState.AttackInPlay)

    pushUndoAction(() => {
      setSelectedAttackDestinationLocation(undefined);
      setCurrentPointState(CurrentPointState.AttackTypeSelected);
    })
  };

  const handleAttackDig = () => {
    if(!assertPointState('handleAttackDig', CurrentPointState.AttackInPlay)) return;

    setCurrentPointState(CurrentPointState.DigTransition);

    pushUndoAction(() => {
      setCurrentPointState(CurrentPointState.AttackInPlay);
    })
  }



  const handleBlockRecycle = () => {
    if(!assertPointState('handleBlockRecycle', CurrentPointState.AttackTypeSelected)) return;

    setCurrentPointState(CurrentPointState.BlockTransition);

    pushUndoAction(() => {
      setCurrentPointState(CurrentPointState.AttackTypeSelected);
    })
  }

  const handleFreeBallClick = () => {
    if(!assertPointState('handleFreeBallClick', CurrentPointState.PassGraded)) return;

    setCurrentPointState(CurrentPointState.FreeBallTransition);

    pushUndoAction(() => {
      setCurrentPointState(CurrentPointState.PassGraded);
    })
  }

  const handlePreAttackTypeFault = () => {
    if(!assertPointState('handlePreAttackTypeFault', CurrentPointState.AttackOriginSelected)) return;
    
    setCurrentPointState(CurrentPointState.Fault);

    pushUndoAction(() => {
      setCurrentPointState(CurrentPointState.AttackOriginSelected);
    })
  }

  const handlePostAttackTypeFault = () => {
    if(!assertPointState('handlePostAttackTypeFault', CurrentPointState.AttackTypeSelected)) return;
        
    setCurrentPointState(CurrentPointState.Fault);

    pushUndoAction(() => {
      setCurrentPointState(CurrentPointState.AttackTypeSelected);
    })
  }
  //endregion

  //region Terminal statting state handlers
  const addPointAndReset = (point: StattedPoint) => {
    const pointToSave = {
      ...point,
      season: match!.season, // Points always belong to their match's season
      setId: selectedSetId!,
    }
    setIsSavingPoint(true);
    savePoint(pointToSave)
      .then((response) => {
        setFullPointHistory(addUiInfoToPoints([...fullPointHistory, response.stattedPoint], homePartnership!.id));
        const previousPointState = resetEphemeralPointState();
        setUndoActionStack(stack => [...stack, () => {
          if(window.confirm('Delete most recently saved point?')) {
            deletePoint(response.stattedPoint.id)
              .then(() => fetchAndUpdateSetPointHistory(match?.season!, selectedSetId!))
              .then(() => setEphemeralPointState(previousPointState))
          }
        }])
      })
      .catch(e => {
        console.error('Failed to save point:', e);
        enqueueSnackbar('Failed to save point', {variant: 'error', autoHideDuration: 5000});
      })
      .finally(() => {
        setIsSavingPoint(false);
      })
  }

  const handleOutOfBoundsServe = (serveOutLocation: ServeOutLocation) => {
    if(!assertPointState('handleOutOfBoundsServe', CurrentPointState.PendingServe)) return;
    assertAllDefined('handleOutOfBoundsServe', servingPartnership, receivingPartnership, servingPlayerId)

    const point = serveOutPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, serveOutLocation);
    addPointAndReset(point);
  }

  const handleServeInNet = () => {
    if(!assertPointState('handleServeInNet', CurrentPointState.PendingServe)) return;
    assertAllDefined('handleServeInNet', servingPartnership, receivingPartnership, servingPlayerId);

    const point = serveInNetPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!);
    addPointAndReset(point);
  }

  const handleServeFault = () => {
    if(!assertPointState('handleServeFault', CurrentPointState.PendingServe)) return;
    assertAllDefined('handleServeFault', servingPartnership, receivingPartnership, servingPlayerId);

    const point = serveFaultPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!);
    addPointAndReset(point);
  }

  const handleAce = () => {
    if(!assertPointState('handleAce', CurrentPointState.ServeInPlay)) return;
    assertAllDefined('handleAce', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation);

    const point = acePoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!);
    addPointAndReset(point);
  }

  const handleBlockKill = () => {
    if(!assertPointState('handleBlockKill', CurrentPointState.AttackTypeSelected)) return;
    assertAllDefined('handleBlockKill', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation)
    const point = blockKillPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!);
    addPointAndReset(point);
  }

  const handleToolKill = () => {
    if(!assertPointState('handleToolKill', CurrentPointState.AttackTypeSelected)) return;
    assertAllDefined('handleToolKill', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackOriginLocation)

    const point = toolKillPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackOriginLocation!);
    addPointAndReset(point);
  }

  const handleAttackKill = () => {
    if(!assertPointState('handleAttackKill', CurrentPointState.AttackInPlay)) return;
    assertAllDefined('handleAttackKill', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation, selectedAttackDestinationLocation)

    const point = attackKillPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!, selectedAttackDestinationLocation!);
    addPointAndReset(point);
  }

  const handlePointAdjudication = (winningPartnershipId: number) => {
    if(currentPointState === CurrentPointState.DigTransition) {
      handleDigTransitionPoint(winningPartnershipId);
    } else if(currentPointState === CurrentPointState.BlockTransition) {
      handleBlockTransitionPoint(winningPartnershipId);
    } else if(currentPointState === CurrentPointState.FreeBallTransition) {
      handleFreeBallTransitionPoint(winningPartnershipId);
    } else if(currentPointState === CurrentPointState.Fault) {
      handleFaultTransitionPoint(winningPartnershipId);
    }
    else {
      console.error('Invalid state for handlePointAdjudication, expected DigTransition, BlockTransition, FreeBallTransition, or Fault but was', currentPointState);
      throw new Error('Invalid state for handlePointAdjudication, expected DigTransition, BlockTransition, FreeBallTransition, or Fault but was ' + currentPointState);
    }
  }

  const handleDigTransitionPoint = (winningPartnershipId: number) => {
    if(!assertPointState('handleTransitionPoint', CurrentPointState.DigTransition)) return;
    assertAllDefined('handleTransitionPoint', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation, selectedAttackDestinationLocation)

    const point = dugTransitionPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!, selectedAttackDestinationLocation!, winningPartnershipId);
    addPointAndReset(point);
  }

  const handleBlockTransitionPoint = (winningPartnershipId: number) => {
    if(!assertPointState('handleBlockTransitionPoint', CurrentPointState.BlockTransition)) return;
    assertAllDefined('handleBlockTransitionPoint', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation)

    const point = blockCoveredTransitionPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!, winningPartnershipId);
    addPointAndReset(point);
  }

  const handleFreeBallTransitionPoint = (winningPartnershipId: number) => {
    if(!assertPointState('handleFreeBallTransitionPoint', CurrentPointState.FreeBallTransition)) return;
    assertAllDefined('handleFreeBallTransitionPoint', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType)

    const point = freeBallTransitionPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, winningPartnershipId);
    addPointAndReset(point);
  }

  const handleFaultTransitionPoint = (winningPartnershipId: number) => {
    if(!assertPointState('handleFaultTransitionPoint', CurrentPointState.Fault)) return;
    assertAllDefined('handleFaultTransitionPoint', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackOriginLocation);

    const point = faultPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackOriginLocation!, winningPartnershipId);
    addPointAndReset(point);
  }

  const handleAttackInNet = () => {
    if(!assertPointState('handleAttackInNet', CurrentPointState.AttackTypeSelected)) return;
    assertAllDefined('attack in net', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation);

    const point = attackInNetPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!);
    addPointAndReset(point);
  }

  const handleAttackOutError = (outLocation: AttackOutLocation) => {
    if(!assertPointState('handleAttackOutError', CurrentPointState.AttackTypeSelected)) return;
    assertAllDefined('attack out', servingPartnership, receivingPartnership, servingPlayerId, selectedServeInPlayLocation, selectedPassType, selectedAttackType, selectedAttackOriginLocation);

    const point = attackOutPoint(pointHistory.length, servingPartnership!, receivingPartnership!, servingPlayerId!, selectedServeInPlayLocation!, selectedPassType!, selectedAttackType!, selectedAttackOriginLocation!, outLocation);
    addPointAndReset(point);
  }
  //endregion

  //region Set management
  const handleCompleteSetClick = async () => {
    if(!homePartnership || !awayPartnership || !match || !selectedSetId) {
      console.error('Cannot complete set, match, set, homePartnership or awayPartnership is not defined, this is a bug');
      return;
    }

    if(matchStattingSettings.keepScore && homePartnership.score === awayPartnership.score) {
      enqueueSnackbar('Cannot complete set, scores are tied', {variant: 'error', autoHideDuration: 5000});
      return;
    }
    const winningPartnershipId = homePartnership.score > awayPartnership.score ? homePartnership.id : awayPartnership.id;

    const completeSetDto: CompleteSetDto = {
      setId: selectedSetId,
      winningPartnershipId
    }
    setIsCompletingSet(true);
    try {
      const updatedMatch = await completeSet(match.id, completeSetDto);
      setMatch(updatedMatch);
    } catch (e) {
      console.error('Failed to complete set:', e);
      enqueueSnackbar('Failed to complete set', {variant: 'error', autoHideDuration: 5000});
    } finally {
      setIsCompletingSet(false);
    }
  }

  const handleStartNewSetClick = async () => {
    const updatedMatch = await startNewSet(match!.id);
    setMatch(updatedMatch);
    setSelectedSetId(updatedMatch.sets[updatedMatch.sets.length - 1].id);
  }

  const canCompleteSet = () => {
    const requiredPropertiesDefined = !!(match && homePartnership && awayPartnership && selectedSetId);
    const scoreIsValid = homePartnership?.score !== awayPartnership?.score;
    return requiredPropertiesDefined && (scoreIsValid || !matchStattingSettings.keepScore);
  }

  const handleSelectedSetChange = (event: SelectChangeEvent<string>) => {
    const setIndexString = event.target.value.split(' ')[0];
    const setIndex = parseInt(setIndexString.slice(1, setIndexString.length)) - 1;
    const set = match?.sets[setIndex]!;
    setSelectedSetId(set.id);
  }
  //endregion

  //region Additional controls
  const swapCourtSides = () => {
    const initialBottomPartnershipId = homePartnership!.id === initialTopPartnershipId ? awayPartnership!.id : homePartnership!.id;
    setInitialTopPartnershipId(initialBottomPartnershipId)
  }

  const handleSettingsClick = () => {
    setMatchStattingSettingsModalOpen(true);
  }

  const handleSettingsClose = () => {
    setMatchStattingSettingsModalOpen(false);
  }

  const handleSettingSave = (settings: MatchStattingSettings) => {
    setMatchStattingSettings(settings);
    handleSettingsClose();
  }
  //endregion

  //region Misc display helpers
  const requiresAdjudication = (currentPointState: CurrentPointState) => {
    return currentPointState === CurrentPointState.DigTransition || currentPointState === CurrentPointState.BlockTransition || currentPointState === CurrentPointState.FreeBallTransition || currentPointState === CurrentPointState.Fault;
  }
  //endregion

  const handleDeletePointClick = (pointId: number) => {
    if(window.confirm('Delete point?')) {
      resetEphemeralPointState();
      setSelectedPointId(null);
      deletePoint(pointId)
        .then(() => fetchAndUpdateSetPointHistory(match!.season, selectedSetId!))
    }
  }

  const handleJumpToCurrentClick = (pointId: number) => {
    resetEphemeralPointState();
    setSelectedPointId(null);
  }

  const handleHistoricalPointClick = (point: StattedPointDto) => {
    resetEphemeralPointState();
    if(point.id === selectedPointId) {
      setSelectedPointId(null);
    } else {
      setSelectedPointId(point.id);
    }
  }

  const courtProps: CourtProps = {
    isRotated: courtIsRotated,
    sectionAdditionalClasses: {
      receivingOutOfBounds: receivingOutOfBoundsAdditionalClasses(),
      receivingInBounds: receivingInBoundsAdditionalClasses(),
      attackLocationOrFree: attackLocationOrFreeAdditionalClasses(),
      shotLocation: shotLocationAdditionalClasses(),
      attackingOutOfBounds: attackingOutOfBoundsAdditionalClasses()
    },
    locationDisplaySettings: {
      showServeReceiveLocation: showServeReceiveLocationsOverride !== undefined ? showServeReceiveLocationsOverride : showServeReceiveLocation(),
      showAttackLocations: showAttackLocationsOverride !== undefined ? showAttackLocationsOverride : showAttackLocations(),
    },
    locationConditionalStyles: {
      attackDestinationSection: attackDestinationSectionStyle,
      attackOriginSection: attackOriginSectionStyle,
      freeBallLocationSection: freeBallLocationSectionStyle,
      serveReceiveSection: serveReceiveSectionStyle,
      attackOutOfBoundsLocation: attackOutOfBoundsLocationStyle,
      serveOutOfBoundLocation: serveOutOfBoundsLocationStyle
    },
    clickHandlers: {
      handleServeReceiveSectionClick,
      handleAttackOriginClick,
      handleAttackDestinationSectionClick,
      handleAttackOutClick: handleAttackOutError,
      handleOutOfBoundsServeClick: handleOutOfBoundsServe,
      handleFreeBallClick
    }
  }

  const matchStattingLeftSidebarProps: MatchStattingLeftSidebarProps = {
    data: {
      match: match!,
      players: [topPartnership?.playerOne!, topPartnership?.playerTwo!, bottomPartnership?.playerOne!, bottomPartnership?.playerTwo!],
      fullPointHistory,
      homePartnership: homePartnership!,
      selectedSet: selectedSet!,
      selectedPointId: selectedPointId!
    },
    handlers: {
      handleSelectedSetChange,
      handleServerPlayerIdChange: setServingPlayerId,
      handleUndoClick,
      handleCompleteSetClick,
      handleStartNewSetClick,
      handleSwapCourtSidesClick: swapCourtSides,
      handleHistoricalPointClick,
      handleSettingsClick
    },
    canCompleteSet,
    canUndo
  }

  const topPartnershipContainerProps: MatchPartnershipContainerProps = {
    handlers: {
      handleUpdatePartnership: (partnership: PartnershipWithState) => updateTopOrBottomPartnershipState(true, partnership),
      handleSetServer: setServingPlayerId
    },
    data: {
      isTopPartnership: true,
      partnership: topPartnership!,
      opponentPartnership: bottomPartnership!,
      pointHistory,
      servingPlayerId
    }
  }

  const bottomPartnershipContainerProps: MatchPartnershipContainerProps = {
    handlers: {
      handleUpdatePartnership: (partnership: PartnershipWithState) => updateTopOrBottomPartnershipState(false, partnership),
      handleSetServer: setServingPlayerId
    },
    data: {
      isTopPartnership: false,
      partnership: bottomPartnership!,
      opponentPartnership: topPartnership!,
      pointHistory,
      servingPlayerId
    }
  }

  return (
    <div className={'page-background'}>
      <MatchStattingSettingsModal open={matchStattingSettingsModalOpen} onClose={handleSettingsClose} settings={matchStattingSettings} onSave={handleSettingSave}/>
      <Box className={`page-content-container-stat-court`}>
        {isLoading ? <LinearProgress/> : topPartnership && bottomPartnership && allPlayerStats &&
        <>
          <Box className={`player-and-court-container-stat-court`}>
            <MatchPartnershipContainer handlers={topPartnershipContainerProps.handlers} data={topPartnershipContainerProps.data}/>
            <Box className={'court-and-button-gutters-container'}>
              <MatchStattingLeftSidebar
                data={matchStattingLeftSidebarProps.data}
                handlers={matchStattingLeftSidebarProps.handlers}
                canUndo={matchStattingLeftSidebarProps.canUndo}
                canCompleteSet={matchStattingLeftSidebarProps.canCompleteSet}
              />
              <div style={{width: '350px', position: 'relative'}}>
                <Court
                  isRotated={courtProps.isRotated}
                  sectionAdditionalClasses={courtProps.sectionAdditionalClasses}
                  locationDisplaySettings={courtProps.locationDisplaySettings}
                  locationConditionalStyles={courtProps.locationConditionalStyles}
                  clickHandlers={courtProps.clickHandlers}
                />
                {/* Loading spinner overlay */}
                {(isSavingPoint || isCompletingSet) && (
                  <Box sx={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000, borderRadius: 1}}>
                    <CircularProgress size={60} sx={{ color: 'white' }} />
                  </Box>
                )}
                {/* Mini popup container for button groups */}
                {(currentPointState === CurrentPointState.ServeInPlay || currentPointState === CurrentPointState.AttackOriginSelected || currentPointState === CurrentPointState.AttackInPlay || requiresAdjudication(currentPointState)) && (
                  <Box sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', borderRadius: 2, boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.4)', p: 2, display: 'flex', flexDirection: 'column', gap: 1, minWidth: '200px', zIndex: 10}}>
                    {currentPointState === CurrentPointState.ServeInPlay && (
                      <>
                        <Button onClick={() => handleAce()} variant={'contained'} fullWidth sx={{ bgcolor: SERVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: SERVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Ace</Button>
                        <Button onClick={() => handlePassGradeClick(PassType.InSystem)} variant={'contained'} fullWidth>In System</Button>
                        <Button onClick={() => handlePassGradeClick(PassType.OutOfSystem)} variant={'contained'} fullWidth>Out of System</Button>
                      </>
                    )}
                    {currentPointState === CurrentPointState.AttackOriginSelected && (
                      <>
                        <Button onClick={() => handleAttackTypeClick(AttackType.Swing)} variant={'contained'} fullWidth>Swing</Button>
                        <Button onClick={() => handleAttackTypeClick(AttackType.Shot)} variant={'contained'} fullWidth>Shot</Button>
                        <Button onClick={() => handlePreAttackTypeFault()} variant={'contained'} fullWidth style={{fontSize: '14px'}}>Fault</Button>
                      </>
                    )}
                    {currentPointState === CurrentPointState.AttackInPlay && (
                      <>
                        <Button onClick={() => handleAttackKill()} variant={'contained'} fullWidth sx={{ bgcolor: RECEIVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: RECEIVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Kill</Button>
                        <Button onClick={() => handleAttackDig()} variant={'contained'} fullWidth>Dig</Button>
                      </>
                    )}
                    {requiresAdjudication(currentPointState) && (
                      <>
                        <Button onClick={() => handlePointAdjudication(servingPartnership!.id)} variant={'contained'} fullWidth sx={{ bgcolor: SERVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: SERVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Serving Team Point</Button>
                        <Button onClick={() => handlePointAdjudication(receivingPartnership!.id)} variant={'contained'} fullWidth sx={{ bgcolor: RECEIVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: RECEIVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Receiving Team Point</Button>
                      </>
                    )}  
                  </Box>
                )}
              </div>
              {selectedPointId !== null ?
              <Box className={'conditional-buttons-gutter'}>
                <Button variant={'contained'} onClick={() => handleJumpToCurrentClick(selectedPointId)}>Jump To Current</Button>
              </Box> :
              <Box className={'conditional-buttons-gutter'}>
                {currentPointState === CurrentPointState.PendingServe && <Button onClick={() => handleServeInNet()} variant={'contained'} sx={{ bgcolor: RECEIVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: RECEIVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Net Serve</Button>}
                {currentPointState === CurrentPointState.PendingServe && <Button onClick={() => handleServeFault()} variant={'contained'} sx={{ bgcolor: RECEIVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: RECEIVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' } }}>Service Fault</Button>}

                {currentPointState === CurrentPointState.AttackTypeSelected && <Button onClick={() => handleToolKill()} variant={'contained'} sx={{ bgcolor: RECEIVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: RECEIVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' }, fontSize: '14px' }}>Tool Kill</Button>}
                {currentPointState === CurrentPointState.AttackTypeSelected && <Button onClick={() => handleBlockKill()} variant={'contained'} sx={{ bgcolor: SERVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: SERVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' }, fontSize: '14px' }}>Block Kill</Button>}
                {currentPointState === CurrentPointState.AttackTypeSelected && <Button onClick={() => handleBlockRecycle()} variant={'contained'} style={{fontSize: '14px'}}>Block Covered</Button>}
                {currentPointState === CurrentPointState.AttackTypeSelected && <Button onClick={() => handlePostAttackTypeFault()} variant={'contained'} style={{fontSize: '14px'}}>Fault</Button>}
                {currentPointState === CurrentPointState.AttackTypeSelected && <Button onClick={() => handleAttackInNet()} variant={'contained'} sx={{ bgcolor: SERVING_TEAM_POINT_COLOR, '&:hover': { bgcolor: SERVING_TEAM_POINT_COLOR, filter: 'brightness(0.9)' }, fontSize: '14px' }}>Ball in Net</Button>}
              </Box>}
            </Box>
            <MatchPartnershipContainer handlers={bottomPartnershipContainerProps.handlers} data={bottomPartnershipContainerProps.data}/>
          </Box>
        </>}
      </Box>
    </div>
  );
};

export default MatchStattingPage;
